import React from "react";
import {
  BannerWrap,
  BannerIcon,
  BannerBody,
  BannerTitle,
  BannerText,
  BannerFooter,
  BannerLinkButton,
} from "./styledComponents";

function StatusBanner({ level, text, onActionClick }) {
  const icon = level === "info" ? "ℹ️" : level === "warning" ? "⚠️" : "⛔";
  const title = level === "info" ? "Info" : level === "warning" ? "Warning" : "Action required";
  return (
    <BannerWrap level={level}>
      <BannerIcon>{icon}</BannerIcon>
      <BannerBody>
        <BannerTitle level={level}>{title}</BannerTitle>
        <BannerText>{text}</BannerText>
        {onActionClick && (
          <BannerFooter>
            <BannerLinkButton onClick={onActionClick}>Go to KYC</BannerLinkButton>
          </BannerFooter>
        )}
      </BannerBody>
    </BannerWrap>
  );
}

export default StatusBanner;

